/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import { useRouter } from 'next/router';
import { useQueryTE } from 'utils/react-query';
import { pipe, either } from 'utils/fp';
import { Button } from 'components/ui_library/Button';
import { conceptsApiEffects, ConceptsParams } from 'modules/Concepts/apiEffects';
import SelectConceptList from './SelectConceptList';

const fetchAppConceptsList = conceptsApiEffects.fetchConceptsListTE;

export interface ConceptDetails {
  id: string;
  name: string;
  value?: number;
}

interface SelectModalConceptProps {
  modalId: string;
  fieldValue: Record<string, string | number>;
  closeModal: (args: { id: string }) => void;
  setFieldValue: (fieldValue: ConceptDetails[]) => void;
}

export const SelectModalConcept = ({ modalId, fieldValue, closeModal, setFieldValue }: SelectModalConceptProps): JSX.Element => {
  const [conceptsValues, setConceptsValues] = useState<any>({});
  const { userOrOrgId, appId } = useRouter().query as { userOrOrgId: string; appId: string };

  const params: ConceptsParams = {
    userId: userOrOrgId,
    appId,
    modelId: '',
    versionId: '',
  };

  const { data: modelConceptListE } = useQueryTE(['Concepts', params], fetchAppConceptsList(params));

  const modelConceptList = pipe(
    modelConceptListE,
    either.fold(
      () => [],
      (data) => data,
    ),
  );

  const handleOkClicked = (): void => {
    closeModal({ id: modalId });
    const conceptMap = modelConceptList.reduce((acc, item: CF.API.Concept) => {
      acc[item.id] = item.name;
      return acc;
    }, {} as Record<string, string>);
    const value = Object.keys(conceptsValues).map((conceptId) => {
      const item: ConceptDetails = {
        id: conceptId,
        name: conceptMap[conceptId],
      };
      item.value = conceptsValues[conceptId];
      return item;
    });
    setFieldValue(value);
  };

  return (
    <>
      <SelectConceptList selectedModelConcepts={modelConceptList} conceptsValues={fieldValue} setConceptsValues={setConceptsValues} showThreshold />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button data-testid="dialogCloseCancel" variant="secondary" onClick={() => closeModal({ id: modalId })}>
          Cancel
        </Button>
        <Button data-testid="dialogCloseOK" onClick={handleOkClicked}>
          Save
        </Button>
      </div>
    </>
  );
};
